import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tooltip } from 'primereact/tooltip';
import { Phase } from '../../../Helper/ApiHelper/KeyValueNetworkHelper';
import { AuthUserType } from '../../../Helper/ApiHelper/LoginNetworkHelper';
import {
  SERVER_RESPONSE_ERROR,
  SERVER_RESPONSE_PENDING
} from '../../../Helper/Statics/Constants';
import { FaktorKeyValueStore } from '../../Molecules/DL/DlBundeslandfaktoren';
import BeeIcon from '../../Atoms/BeeIcon';
import BeeLoadingSpinner from '../../Atoms/BeeLoadingSpinner';
import BeeOutlinedButton from '../../Atoms/BeeOutlinedButton';
import BeeValidatedCheckbox from '../../Atoms/BeeValidatedCheckbox';
import './AlphaPhaseParticipationTable.scss';
import BeeContentHeadline from '../../Atoms/BeeContentHeadline';

type AlphaPhaseUserTableProps = {
  phase: Phase;
  serviceProvider: AuthUserType[];
  participationState: { [userId: string]: FaktorKeyValueStore };

  onParticipationChange: (
    phase: Phase,
    userId: string,
    checked: boolean,
    previousValue: boolean
  ) => void;
  onOpenEpCatalog?: (
    phase: Phase,
    user: AuthUserType,
    readOnly: boolean
  ) => void;
};

export default function AlphaPhaseParticipationTable({
  phase,

  serviceProvider,
  participationState,
  onParticipationChange,
  onOpenEpCatalog
}: AlphaPhaseUserTableProps) {
  const phaseHasEnded =
    phase.end != null ? new Date(phase.end).getTime() < Date.now() : false;

  const renderParticipationCell = (rowData: AuthUserType) => {
    const key = `${phase.id}_${rowData.id}`;
    const status = participationState[key];
    const isPending = status?.process === SERVER_RESPONSE_PENDING;
    const isError = status?.process === SERVER_RESPONSE_ERROR;
    const value = status?.value ?? false;
    return (
      <div className={'user-to-phase-checkbox'}>
        <BeeValidatedCheckbox
          label={''}
          value={value}
          disabled={isPending}
          formstate={'neutral'}
          stateFalse={''}
          stateTrue={''}
          required={false}
          readOnly={isPending}
          onChange={(e) =>
            onParticipationChange(
              phase,
              rowData.id,
              e.checked,
              status?.value ?? false
            )
          }
        />
        {isPending ? (
          <span className={'user-to-phase-checkbox__status-userChange pending'}>
            <BeeLoadingSpinner strokeWidth={'3'} type={'primary'} />
          </span>
        ) : null}
        {isError ? (
          <span
            className={
              'user-to-phase-checkbox__status-userChange error tooltip-participation-error'
            }
          >
            <BeeIcon
              iconClass={'pi pi-exclamation-triangle'}
              type={'primary'}
            />
            <span>{'Fehler'}</span>
          </span>
        ) : null}
      </div>
    );
  };

  const renderHeadline = () => {
    const start = phase.start ? new Date(phase.start) : null;
    const end = phase.end ? new Date(phase.end) : null;
    return (
      <div className={'phase-to-doc-headline'}>
        <BeeContentHeadline
          label={phase.title}
          headline={'h2'}
          type={'primary'}
        />
        <BeeContentHeadline
          label={
            start && end
              ? start.toLocaleDateString('de-DE') +
                ' - ' +
                end.toLocaleDateString('de-DE')
              : ''
          }
          headline={'h3'}
          type={'secondary'}
        />
      </div>
    );
  };
  function renderActionCell(rowData: AuthUserType) {
    const key = `${phase.id}_${rowData.id}`;
    const status = participationState[key];
    const value = status?.value ?? false;
    if (!value) {
      return null;
    }
    return (
      <div className={'phase-user-action'}>
        <BeeOutlinedButton
          label={
            phaseHasEnded ? 'Leistungszuordnung ansehen' : 'Leistungen zuordnen'
          }
          type={'secondary'}
          disabled={!onOpenEpCatalog}
          onClick={() => onOpenEpCatalog?.(phase, rowData, phaseHasEnded)}
        />
      </div>
    );
  }
  const renderTable = () => (
    <div className={'phase-participation-table'}>
      <DataTable
        value={serviceProvider}
        className={'phase-participation-datatable'}
        dataKey={'id'}
        scrollable={false}
        size={'small'}
        emptyMessage={'Keine Nutzer vorhanden.'}
        responsiveLayout={'scroll'}
        stripedRows={true}
      >
        <Column
          key={'Nutzer'}
          header={'Nutzer'}
          body={(rowData: AuthUserType) => (
            <div className={'phase-user-name'}>{rowData.username}</div>
          )}
          className={'phase-user-name-col'}
        />
        <Column
          key={'Teilnahme'}
          header={'Teilnahme'}
          body={(rowData: AuthUserType) => renderParticipationCell(rowData)}
          className={'phase-user-participation-col'}
        />
        <Column
          key={'Aktion'}
          header={'Aktion'}
          body={(rowData: AuthUserType) => renderActionCell(rowData)}
          className={'phase-user-action-col'}
        />
      </DataTable>
      <Tooltip
        target={'.tooltip-participation-error'}
        mouseTrack
        mouseTrackLeft={10}
      >
        {
          'Die Änderung konnte nicht gespeichert werden. Bitte prüfen Sie Ihre Internetverbindung.'
        }
      </Tooltip>
    </div>
  );

  return (
    <div className={'alpha-phase-user-table pt-4 pb-4'}>
      {renderHeadline()}
      {renderTable()}
    </div>
  );
}
